import React from 'react'
import PropTypes from 'prop-types'

function DualRowColumn ({ header, children }) {
  return (
    <div className='flex items-center'>
      <div>
        <div className='text-sm leading-5 font-medium text-gray-900'>
          {header}
        </div>
        <div className='text-sm leading-5 text-gray-500 truncate max-w-xs'>
          {children}
        </div>
      </div>
    </div>
  )
}

DualRowColumn.defaultProps = {
  header: null,
  children: null
}

DualRowColumn.propTypes = {
  /**
     * Header content
     */
  header: PropTypes.node.isRequired,
  /**
     * 2nd row content
     */
  children: PropTypes.node.isRequired
}

export default DualRowColumn
